import React, { Fragment } from 'react';
import Image from '../../../basic/image'
import emexru from '../../../static/emexru.png'
import partkomru from '../../../static/partkomru.png'
import existru from '../../../static/existru.png'
import autodocru from '../../../static/autodocru.png'
import adeoproru from '../../../static/adeoproru.png'
import autorusru from '../../../static/autorusru.png'
import bergru from '../../../static/bergru.png'
import autostelsru from '../../../static/autostelsru.png'
import autopiterru from '../../../static/autopiterru.png'
import avtotoru from '../../../static/avtotoru.png'
import bazashopru from '../../../static/bazashopru.png'
import autosnabkru from '../../../static/autosnabkru.png'
import автосоюзюгрф from '../../../static/автосоюзюгрф.png'
import binomautoru from '../../../static/binomautoru.png'
import detalonlineru from '../../../static/detalonlineru.png'
// import aslogo from '../../../static/as-logo.png'
import magistralnnru from '../../../static/magistralnnru.png'
import shatemru from '../../../static/shatemru.png'
import spomgru from '../../../static/spomgru.png'
import topdetalru from '../../../static/topdetalru.png'
import topolekru from '../../../static/topolekru.png'
import ugautodetalru from '../../../static/ugautodetalru.png'
import fu from '../../../static/fu.png'
import rvs from '../../../static/rvs.png'
import trinity from '../../../static/trinity.png'
import ixora from '../../../static/ixora.jpg'
import alpina from '../../../static/alpina.png'
import atrast from '../../../static/atrast.png'
import atiru from '../../../static/03atiru.png'
// import interrus from '../../../static/interrus.png'
import uaot from '../../../static/uaot.png'
import existua from '../../../static/existua.png';
import finwhaleua from '../../../static/finwhaleua.jpg';
import begautoua from '../../../static/begautoua.png';
import rozetkaua from '../../../static/rozetkaua.png';
import optimalautoua from '../../../static/optimalautoua.png';
import mobilluckua from '../../../static/mobilluckua.png';
import dokua from '../../../static/dokua.png';
import autokladua from '../../../static/autokladua.png';
import mosteknorot from '../../../static/mos-teknorot.png';
import autodocua from '../../../static/autodocua.png';
import auto3n from '../../../static/stores/auto3n.png';
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


function Card({href, label, image}) {
  return (
    <div style={{
      display: 'inline-block',
      width: '100%',
      textAlign: 'center',
      marginBottom: 24,
      minWidth: 230,
      marginRight: 10,
      height: 100,
      border: '1px solid rgb(221,221,221)',
      verticalAlign: 'top',
    }}>
      <a href={href} style={{display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
        <Image
          src={image}
          className="cover-image"
          containerStyle={{
            alignSelf: 'center',
            maxHeight: 90,
          }}
          style={{
            maxHeight: 90,
            maxWidth: '95%',
          }}
        />
        {label && <div>{label}</div>}
      </a>
    </div>
  )
}

export default function Banner(props) {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return (
          <div>
            <div
              style={{
                marginBottom: 40,
                fontSize: 24,
                fontWeight: '800',
                textAlign: 'center',
              }}
            >
              <TranslateText id="buy__online_stores" />
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
              }}
            >
              {currentLanguage === 'ua' ?
                <Fragment>
                  <Card
                    href="https://exist.ua/"
                    image={existua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://finwhale.com.ua"
                    image={finwhaleua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://beg-auto.com/index.php?route=product/category/search&keyword=Finwhale"
                    image={begautoua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://rozetka.com.ua/search/?text=Finwhale&producer=434768"
                    image={rozetkaua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://optimal-auto.com.ua"
                    image={optimalautoua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://www.mobilluck.com.ua/search.php?sw=Finwhale"
                    image={mobilluckua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://dok.dbroker.com.ua/catalog/tormoznyie-kolodki/brand-finwhale"
                    image={dokua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://www.autoklad.ua/select/komplekty_scepleniya/finwhale/"
                    image={autokladua}
                    rel="nofollow"
                  />
                  <Card
                    href="https://autodoc.ua/search-result?searchPhrase=Finwh"
                    image={autodocua}
                    rel="nofollow"
                  />
                </Fragment>
                :
                <Fragment>
                  <Card
                    href="https://mosteknorot.ru/"
                    image={mosteknorot}
                    rel="nofollow"
                  />
                  <Card
                    href="https://www.emex.ru/"
                    image={emexru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://part-kom.ru/"
                    image={partkomru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://exist.ru/"
                    image={existru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://autodoc.ru/"
                    image={autodocru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://adeo-pro.ru/"
                    image={adeoproru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://autorus.ru/"
                    image={autorusru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://berg.ru/"
                    image={bergru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://autostels.ru/"
                    image={autostelsru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://autopiter.ru/"
                    image={autopiterru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://avtoto.ru/"
                    image={avtotoru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://bazashop.ru/"
                    image={bazashopru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://autosnab-k.ru/"
                    image={autosnabkru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://автосоюз-юг.рф/"
                    image={автосоюзюгрф}
                    rel="nofollow"
                  />
                  <Card
                    href="http://binom-auto.ru/"
                    image={binomautoru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://detalonline.ru/"
                    image={detalonlineru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://magistral-nn.ru/"
                    image={magistralnnru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://shate-m.ru/"
                    image={shatemru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://spomg.ru/"
                    image={spomgru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://topdetal.ru/"
                    image={topdetalru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://topolek.ru/"
                    image={topolekru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://ugautodetal.ru/"
                    image={ugautodetalru}
                    rel="nofollow"
                  />
                  <Card
                    href="http://03ati.ru/"
                    image={atiru}
                    rel="nofollow"
                  />
                  {/* <Card
                    href="https://auto-sputnik.ru/"
                    image={aslogo}
                    rel="nofollow"
                  /> */}
                  <Card
                    href="http://forum-auto.ru/"
                    image={fu}
                    rel="nofollow"
                  />
                  <Card
                    href="https://rvs-avto.ru/"
                    image={rvs}
                    rel="nofollow"
                  />
                  <Card
                    href="http://trinity-parts.ru/"
                    image={trinity}
                    rel="nofollow"
                  />
                  <Card
                    href="https://ixora-auto.ru/"
                    image={ixora}
                    rel="nofollow"
                  />
                  <Card
                    href="https://www.alpinashop.ru/"
                    image={alpina}
                    rel="nofollow"
                  />
                  <Card
                    href="https://a-trast.ru/"
                    image={atrast}
                    rel="nofollow"
                  />
                  <Card
                    href="https://uaot.info/"
                    image={uaot}
                    rel="nofollow"
                  />
                  <Card
                    href="https://auto3n.ru"
                    image={auto3n}
                    rel="nofollow"
                  />
                </Fragment>
              }
            </div>
          </div>
        );
      }}
    </CurrentLanguageContext.Consumer>
  )
}



// WEBPACK FOOTER //
// ./src/finwhale/common/retail-stores/Mobile.js